"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDay = void 0;
const dayjsCore_1 = require("./dayjsCore");
const getDay = (eventDate) => {
    return (0, dayjsCore_1.dayjsCore)(eventDate).format('DD-MM');
};
exports.getDay = getDay;
//# sourceMappingURL=getDay.js.map